export interface IDialogConfig {
	panelClass?: DialogClass | string | DialogClass[] | string[];
	disableClose?: boolean;
	height?: string;
	maxHeight?: string | number;
	data: any;
}

export enum DialogClass {
	small = 'dialog-small',
	medium = 'dialog-medium',
	large = 'dialog-large'
}
